import React, {useState} from "react";
import '../../styles/AddParticipnatsForm.css';
import { AES } from 'crypto-js';
import { db } from '../../firebase.js'
import { addDoc, collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore"; 

function AddOrganizationForm () {

    const [formData, setFormData] = useState({
        firstName: '',
        email: '',
        
    });

    const secretKey = "57DAD6C5B3A9C7B18E9D2C475C3CB";

    const submitUser = async (event) => {
        event.preventDefault();

        const encryptedEmail = AES.encrypt(formData.email, secretKey).toString();

        const userData = {
            firstName: formData.firstName,
            email: formData.email,
            role: ["ORGANIZATION"],
            encrypted_email: encryptedEmail,
            lastName: ' ',
            staff: false,
            isResearcher: false,
            tSize: ' ',
            day1CheckedIn: false,
            day2CheckedIn: false,
            isBag: true,
            isConfKit: true,
            isNotebook: true,
            isTShirt: true,
            main_role: "ORGANIZATION",
            ticket_day_1: true,
            ticket_day_2: true,
        };

	    // Check if the email already exists and get the user data
        const existingUserData = await checkIfEmailExists(formData.email);

        if (existingUserData) {
            // Email exists, check the role
            if (Array.isArray(existingUserData.role)) {
                if (!existingUserData.role.includes("ORGANIZATION")) {
                    // Add "ATTENDEE" to the role array
                    // existingUserData.role.push("ORGANIZATION");
                    // updateParticipantInFirestore(existingUserData);
                    window.alert("Email already exists in the collection as ORGANIZATION");

                } else {
                    window.alert("Email already exists in the collection as ORGANIZATION");
                }
            } else {
                existingUserData.role = ["ORGANIZATION"];
                window.alert("Email already exists in the collection as ORGANIZATION");

                // updateParticipantInFirestore(existingUserData);
            }
        } else {
            // Email does not exist, add the new user
            addParticipantToFirestore(userData);
        }

        
    };

    

    const userChange = (event) => {
        const { name, type, checked } = event.target;
        
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : event.target.value,
        }));
    };
    

    const addParticipantToFirestore = async (userData) => {
        try {
            // Add a new document with a generated ID to the "participants" collection
            await addDoc(collection(db, "participant"), userData);
            window.alert("User data saved to Firestore");
    
            // Reset form data
            setFormData(prevState => ({
                ...prevState,
                firstName: '',
                email: '',
                
            }));
    
        } catch (error) {
            console.error("Error saving user data: ", error);
            window.alert("Error saving user data: " + error.message);
        }
    };

    // Function to update an existing document
    const updateParticipantInFirestore = async (userData) => {
        try {
            const docRef = doc(db, 'participant', userData.id); // Replace 'userData.id' with the actual document ID
            await updateDoc(docRef, userData);
            window.alert('User data updated in Firestore');
    
            // Reset form data
            setFormData(prevState => ({
                ...prevState,
                firstName: '',
                email: '',
               
            }));
            
        } catch (error) {
            console.error('Error updating user data: ', error);
            window.alert('Error updating user data: ' + error.message);
        }
    };
    

    const checkIfEmailExists = async (email) => {
        // Reference the "participants" collection and create a query
        const participantsCollection = collection(db, "participant");
        const q = query(participantsCollection, where("email", "==", email));

        // Execute the query and check if any documents are returned
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            // Return the first document's data
            const user = querySnapshot.docs[0].data();
            const userId = querySnapshot.docs[0].id;
            return { id: userId, ...user };
        }
        return null;
    };


    
    return (

        <form onSubmit={submitUser} id ="userFormId">
            <div className="new-user">
                
                <h4>Add Organizations</h4>
                
                <div className="new-user__controls">
                    
                    <div className="new-user__control">
                        <label>Company Name: </label>
                        <input type="text"name="firstName" required value={formData.firstName} onChange={userChange} />
                    </div>
                    
                    <div className="new-user__control">
                        <label>Email:</label>
                        <input type="email" name="email" required value={formData.email} onChange={userChange} />
                    </div>
                    
                    
                </div>
                
                <button type="submit">Add</button>
                
            </div>
        </form>
    );
    
}

export default AddOrganizationForm;